import Swal from 'sweetalert2'


export function isValidValue(value: any): boolean {
  return value != null && value !== '' && !(Array.isArray(value) && value.length === 0);
}


export function getUserRoles(): string[] {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return [];
    const u = JSON.parse(raw);
    return Array.isArray(u?.roles) ? u.roles : [];
  } catch {
    return [];
  }
}


export function autorizzazionePresente<T>(arr1: T[], arr2: T[]): boolean {
  console.log(arr1);
  console.log(arr2);



  if (!arr2 || arr2.length === 0) return true
  if (!arr1 || arr1.length === 0) return false
  //return arr2.some(role => arr1.includes(role))

  return arr1.some(element => arr2.includes(element));
}


export function toNumber(value: any): number {
  if (value === null || value === undefined || value === "") return 0;

  if (typeof value === "number") return value;

  return Number(
    String(value)
      .replace(",", ".")
      .replace(/[^\d.-]/g, "")
  ) || 0;
}

export function formatCurrency(value: any, defaultValue: any = ""): string {
  const rawValue =
    value !== null && value !== undefined && value !== ""
      ? value
      : defaultValue;

  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return "";
  }

  const numericValue = Number(rawValue);

  if (Number.isNaN(numericValue)) {
    return "";
  }

  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(numericValue);
}

export function getWeekNumber(d: Date): [number, number] {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((date.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return [date.getUTCFullYear(), weekNo];
}

export function alertCommessa(commessa: any): boolean {
  if (commessa.lockAnagraficaUtente != '') {
    Swal.fire({
      text: "commessa occupata da " + commessa.lockAnagraficaUtente,
      icon: 'error',
      confirmButtonText: 'Ok'
    })
    return false
  } else {
    return true


  }
}


  export function addRowText(itemRef: any, campo: any, tempRef: any): void  {
    if (!itemRef?.value) return
    if (!campo) return
    if (!tempRef?.value?.trim()) return

    // il valore arriva dal DB con a capo \r\n (anche \r\r\n sui dati sporchi): lo riporto a \n,
    // altrimenti il backend aggiunge un \r a ogni riga esistente e le righe vuote crescono
    const valoreAttuale = String(itemRef.value[campo] || '')
      .replace(/\r*\n|\r+/g, '\n')
      .replace(/^\n+|\n+$/g, '')

    const nuovaRiga = tempRef.value.trim()
    itemRef.value[campo] = valoreAttuale ? `${nuovaRiga}\n${valoreAttuale}` : nuovaRiga
    tempRef.value = ''
  }

  export function addRowTextWithUser(itemRef: any, campo: any, tempRef: any): void  {
    if (!itemRef?.value) return
    if (!campo) return
    if (!tempRef?.value?.trim()) return

    const oggi = new Date()

      const ore = String(oggi.getHours()).padStart(2, '0')
      const minuti = String(oggi.getMinutes()).padStart(2, '0')

    const data = `${String(oggi.getDate()).padStart(2, '0')}/${String(
      oggi.getMonth() + 1
    ).padStart(2, '0')}`

    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const nomeUtente = user.name || ''

/*     const valoreAttuale = itemRef.value[campo] || ''
 */
    tempRef.value = `${data} ${ore}:${minuti} ${nomeUtente} ${tempRef.value.trim()}`

    addRowText(itemRef, campo, tempRef)

    /* itemRef.value[campo] =
      `${data} ${nomeUtente} ${tempRef.value.trim()}\n${valoreAttuale}`

    tempRef.value = '' */
  }

  export function addRowTextWithUserAndHour(itemRef: any, campo: any, tempRef: any): void  {
      const now = new Date()
      const ore = String(now.getHours()).padStart(2, '0')
      const minuti = String(now.getMinutes()).padStart(2, '0')

      //tempRef.value = `${tempRef.value.trim()} ${ore}:${minuti}`
      tempRef.value = `${tempRef.value.trim()}`

      addRowTextWithUser(itemRef, campo, tempRef)
  }


